import request from '@/utils/request2';
export function postList(data) {
  return request.post('admin/company/post/list', data);
}
export function postStatus(data) {
  return request.post('admin/company/post/status', data);
}
export function postDelete(data) {
  return request.post('admin/company/post/delete', data);
}
export function addPost(data) {
  return request.post('admin/company/post/store', data);
}
export function editPost(data) {
  return request.post('admin/company/post/edit', data);
}